/**
 * API base URL.
 *
 * Default "/api" assumes the Function App is linked to the Static Web App as a
 * backend, which makes calls same-origin: no CORS, no extra AppDomain, and the
 * Function App can be firewalled to accept traffic only from SWA.
 *
 * If you have not linked the backend, set VITE_API_BASE at build time to the
 * direct Function App URL and add that origin to the API's ALLOWED_ORIGINS.
 *
 *   VITE_API_BASE=https://quickslides-api.azurewebsites.net/api npm run build
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? "/api";
